import { FilterActions, FilterLabels } from '@aboutyou/legacy-tracking-sdk'
import { useCallback } from 'react'
import { getCurrentSelectionForSlug } from '../../../sharedComponents/ProductStream/filters/filterTracking'
import { useFilterStore } from '../../../store/sidecar/ProductStreamContext'
import { useTracking } from './useTrackingContextAndClientV6'

const useTrackFilter = () => {
  const { TrackingClient } = useTracking()
  const filterStore = useFilterStore()

  return useCallback(
    (filterName: string, action: FilterActions, label: FilterLabels) => {
      let selection = getCurrentSelectionForSlug(filterStore, filterName)

      if (!selection && (filterName === 'sort' || filterName === 'view')) {
        selection = {
          slug: filterName,
          selectedValue: [],
          filterType: 'attribute',
        }
      }

      if (selection) {
        TrackingClient?.trackMainFilterSelection({ selection, action, label })
      }
    },
    [TrackingClient],
  )
}

export const useTrackOnCloseFilter = () => {
  const filterTracker = useTrackFilter()

  return (filterSlug: string, label: FilterLabels) => {
    filterTracker(filterSlug, 'close', label)
  }
}

export const useTrackOnOpenFilter = () => {
  const filterTracker = useTrackFilter()

  return (filterSlug: string, label: FilterLabels) => {
    filterTracker(filterSlug, 'click', label)
  }
}
